// Consultation/ConsultationsWrapper.tsx
import React from 'react';
import ConsultationItem from 'Consultation/ConsultationItem';
import {IConsultation} from "../../Types/psychology/consultation";

interface ConsultationsWrapperProps {
    style?: React.CSSProperties;
    className?: string;
    consultations: IConsultation[];
    actionsEnable?: boolean;
}

const ConsultationsWrapper: React.FC<ConsultationsWrapperProps> = (
    {
        style,
        className = '',
        consultations,
        actionsEnable = true,
    }) => {
    return (
        <div style={style}
             className={`${className} fc gap-2 overflow-y-auto no-scrollbar`}
        >
            {consultations.map((consultation) => (
                <ConsultationItem
                    actionsEnable={actionsEnable}
                    key={consultation.id}
                    consultation={consultation}
                />
            ))}
        </div>
    );
};

export default ConsultationsWrapper;
